module.exports = __webpack_public_path__ + "img/consulta-ja-logo-colorida.a819a8e0.svg";